/**
 * @module NetPrice
 * @return {Object} public methods.
 */
const NetPrice = (function () {
    var $showNetPrice;
    var $netPrice;

    function init() {
        $showNetPrice = $('#show-net-price');

        if ($showNetPrice.length === 0) return false;

        getDOMElements();
        addEventListeners();

        if ($showNetPrice && $netPrice) {
            $showNetPrice.show();
            $netPrice.hide();
        }
    }

    function getDOMElements() {
        $netPrice = $('#net-price');
    }

    function addEventListeners() {
        $showNetPrice.click(onShowNetPriceClick);
    }

    function onShowNetPriceClick(e) {
        e.preventDefault();

        if (!$netPrice.is(":visible")) {
            $showNetPrice.hide();
            $netPrice.velocity("fadeIn", {duration: 300});
        }

        return false;
    }

    // Return public methods
    return {
        init: init
    };
})();

window.NetPrice = NetPrice;
export default NetPrice;
